import * as React from "react";
const SvgFiRrTruckMoving = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m23.641 10.76-1.009-3.025A3.99 3.99 0 0 0 18.838 5H16.9A5.01 5.01 0 0 0 12 1H5a5.006 5.006 0 0 0-5 5v13.5a3.517 3.517 0 0 0 6 2.447 3.517 3.517 0 0 0 6-2.447V19h3v.5a3.5 3.5 0 1 0 7 0v-1.037A4 4 0 0 0 24 15v-2.026a7 7 0 0 0-.359-2.214m-2.906-2.392L21.612 11H17V7h1.838a2 2 0 0 1 1.897 1.368M2 6a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v11H2zm1.5 15A1.5 1.5 0 0 1 2 19.5V19h3v.5A1.5 1.5 0 0 1 3.5 21m6.5-1.5a1.5 1.5 0 0 1-3 0V19h3zm10 0a1.5 1.5 0 1 1-3 0V19h3zm0-2.5h-3v-4h5v2a2 2 0 0 1-2 2"
    />
  </svg>
);
export default SvgFiRrTruckMoving;
